import * as React from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';

// A select input with a clear button to remove the selection.
// Using an Autocomplete, because MUI doesn't have a clearable select.
export default function OptionalSelect({value, options, label, handleChange}) {
  return (
    <Autocomplete
      disablePortal
      onChange={handleChange}
      value={value}
      options={options}
      renderInput={({inputProps, ...rest}) => (
        <TextField
          {...rest}
          label={label}
          inputProps={{
            ...inputProps,
            readOnly: true,
            sx: {cursor: 'pointer'},
          }}
        />
      )}
    />
  );
}
